import { Divider } from '@mui/material';

const CustomDivider = () => (
    <Divider sx={{ border: 'none', backgroundColor: '#000', height: '3px' }} />
);

export default CustomDivider;